import { graphql } from '@/generated/gql';

export const INTAKE_NUCLEAR_COMPLIANCE_FORM_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeNuclearComplianceFormSubmit($chatSessionId: UUID!, $data: JSON!) {
    sevenbridges {
      chatSession {
        request {
          submitComplianceFormData(chatSessionId: $chatSessionId, complianceFormData: $data) {
            id
            complianceFormData
          }
        }
      }
    }
  }
`);
